import { defineMessages } from 'react-intl';

export const DOMAIN_NAME = 'listener' as const;

export const UNDERAGE_BLOCK = 'underageblock' as const;

export const messages = defineMessages({
  thumbs: {
    id: 'thumbs',
    defaultMessage: 'Thumbs',
  },
});
